import HistoryIcon from '@mui/icons-material/HistoryRounded';
import { EventCardDensity } from '@cogneed/design-system';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PanelLayout from '../../../PanelLayout';
import { DetectionGroup } from '../../../../Contexts/DetectionGroupContext';
import useDetectionGroups from '../../../../Contexts/DetectionGroupContext/useDetectionGroups';
import DecisionTreeRunListItem from './Components/DecisionTreeRunListItem';
import DetectionGroupListItem from './Components/DetectionGroupListItem';
import Legend from './Components/Legend';
import { CardList, CountBadge, EmptyState } from './styles';
import useLiveFeedItems from './useLiveFeedItems';

interface InnerDetectionListProps {
  detectionGroups: DetectionGroup[];
  density?: EventCardDensity;
}

export function InnerDetectionList(props: InnerDetectionListProps) {
  const { t } = useTranslation();
  const { detectionGroups, density = 'panel' } = props;
  const feedItems = useLiveFeedItems(detectionGroups);
  if (feedItems.length === 0) {
    return (
      <EmptyState>
        <span className="dot" />
        <Typography variant="body2">{t('detections.empty')}</Typography>
      </EmptyState>
    );
  }
  return (
    <CardList role="list">
      {feedItems.map((item, index) => (
        item.kind === 'detection'
          ? <DetectionGroupListItem key={item.key} detectionGroup={item.detectionGroup} index={index} density={density} />
          : <DecisionTreeRunListItem key={item.key} run={item.run} density={density} />
      ))}
    </CardList>
  );
}

export default function DetectionList() {
  const detectionGroups = useDetectionGroups();
  const { t } = useTranslation();
  return (
    <PanelLayout
      icon={<HistoryIcon />}
      title={t('detections.live')}
      badge={detectionGroups.length > 0 && <CountBadge>{detectionGroups.length}</CountBadge>}
      secondaryRow={detectionGroups.length > 0 && <Legend />}
    >
      <InnerDetectionList detectionGroups={detectionGroups} />
    </PanelLayout>
  );
}
